"use client";

import React, { useState, useRef, useEffect } from "react";
import dynamic from "next/dynamic";
import { X } from "lucide-react";
import { createPortal } from "react-dom";
import FilterBar from "@/app/cin_booking_engine/Filterbar";
import { BookingEngineProvider } from "@/app/cin_context/BookingEngineContext";
import PortfolioSkeleton from "@/components/SkeletonComponent/PortFolioSection";
import ExperiencesSkeleton from "@/components/SkeletonComponent/ExperienceSkeleton";
import ExploreSkeleton from "@/components/SkeletonComponent/ExploreSectionSkeleton";
import ResponsiveBrandSlider from "@/components/ResponsiveBrandSlider";
import Header from "@/components/Header";
import HeroBannerVideo from "./HeroBanner";
import RatePingConfirmationCancellation from "./ratePingConfirmationCancellation";
import { useForm } from "@/components/FormContext";

const ExperienceSection = dynamic(
  () => import("@/components/ExperienceSection"),
  {
    ssr: false,
    loading: () => <ExperiencesSkeleton />,
  },
);

const PortfolioStats = dynamic(() => import("@/components/PortfolioStats"), {
  ssr: false,
  loading: () => <PortfolioSkeleton />,
});

const ExploreSection = dynamic(() => import("@/components/ExploreSection"), {
  ssr: false,
  loading: () => <ExploreSkeleton />,
});

export default function HomeWrapper({ contentData, tokenKey, ratePingCode,
queryPromoCode,
ratePingConfirmationCode,
ratePingConfirmationCacellation}) {
  const [isOpen, setOpen] = useState(false);
  const [showFilterBar, setShowFilterBar] = useState(false);
  const filterBarRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isOpenFilterBar, openFilterBar] = useState(false);
  const [staahPropertyId, setStaahPropertyId] = useState(null);
  const [cityDetails, setCityDetails] = useState(null);
  const [isHandleSearchProp, setHandleSearchProp] = useState(false);
  const [staahOfferId, setStaahOfferId] = useState(0);
    const [openRatePingConfirmation, setOpenRatePingConfirmation] = useState(false);
  const [ratePingConfirmationCancellation, setRatePingConfirmationCancellation] = useState(null);

    const { cityDropDown, properties,
        ghaValidData,
        ghaPropertyIdData,
        ghaCheckInData,
        ghaCheckOutData,
        ghaAdultsData,
        ghaChildrenData,
        ghaPropertyNameData,
        ghaCityNameData,
        ghaCityIdData,
        ghaUtmSourceData } = useForm();

  const handlePropertyBookNow = async (newProperty = null) => {
    if (window.innerWidth < 768) {
      setOpen((prev) => !prev);
      setShowFilterBar((prev) => !prev);
    }
    
    let prperty = {};
    if(parseInt(newProperty?.propertyOfferId) > 0 && newProperty?.property){
      setStaahOfferId(parseInt(newProperty?.propertyOfferId));
      prperty = newProperty?.property
    }else{
      prperty = newProperty;
      setStaahOfferId(0);
    }
    const label = prperty?.cityName;
    const value = prperty?.cityId;
    const property_Id = prperty?.staahPropertyId;
    setCityDetails({ label, value, property_Id });
    setStaahPropertyId(prperty?.staahPropertyId);
    setHandleSearchProp(true);

    if (filterBarRef.current) {
      filterBarRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      const firstInput = filterBarRef.current.querySelector(
        "input, select, button",
      );
      if (firstInput) firstInput.focus();
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      setShowFilterBar(window.innerWidth >= 768);
      setIsMobile(window.innerWidth < 768);
    }
  }, []);

  useEffect(() => {
    if (tokenKey) {
      openFilterBar((prev) => !prev);
    }
  }, [tokenKey]);

  useEffect(() => {
    if (queryPromoCode) {
     handlePropertyBookNow();
    }
  }, [queryPromoCode]);
  
  useEffect(() => {
    if (ratePingCode) {
     handlePropertyBookNow();
    }
  }, [ratePingCode]);

  
  useEffect(() => {
    if (ghaValidData && ghaPropertyIdData) {
      setCityDetails({
        label: ghaCityNameData || "",
        value: ghaCityIdData || "",
        property_Id: ghaPropertyIdData,
      });
      setStaahPropertyId(ghaPropertyIdData);
      setShowFilterBar(true);
    }
  }, [ghaValidData, ghaPropertyIdData, ghaCityNameData, ghaCityIdData]);

   useEffect(() => {
     if (ratePingConfirmationCode && ratePingConfirmationCacellation) {
      //console.log("ratePingConfirmation HomePage", ratePingConfirmation);
      setOpenRatePingConfirmation(true);
      if(ratePingConfirmationCacellation === "A-992834"){
      setRatePingConfirmationCancellation("A");
      }else{
        
      setRatePingConfirmationCancellation("D");
      }
     }else{
      setOpenRatePingConfirmation(false);
     }
   }, [ratePingConfirmationCode]);

  const handlePropertyBookNow3 = async () => {
    setOpen(false);
    setShowFilterBar(false);
  };
  const CloseBookingEngine = async () => {
    setOpen(true);
    setShowFilterBar(true);
  };

const onClickHandle = async () => {
    setOpenRatePingConfirmation(false);
  };
  return (
    <>
      <Header
        onClick={handlePropertyBookNow}
        onClickHotel={handlePropertyBookNow3}
        onCloseBookingEngine={CloseBookingEngine}
      />
      {/* <HotelBookingBanner /> */}
      <section ref={filterBarRef} className="position-relative banner-section">
        
        <HeroBannerVideo />

        <section className="booking-form-section">
          {isMobile && (
            <div
              className={`booking-search-bar-btn-div home-page-class`}
              style={{ zIndex: 10 }}
            >
              <button
                onClick={(e) => {
                  e.preventDefault();
                  handlePropertyBookNow();
                }}
                className="booking-toggle-btn"
              >
                {isOpen ? <X size={18} color="black" /> : "Book Now"}
              </button>
            </div>
          )}
          {isOpenFilterBar &&
            typeof window !== "undefined" &&
            createPortal(
              <BookingEngineProvider>
                <FilterBar
                  contentData={contentData}
                  tokenKey={tokenKey}
                  selectedProperty={0}
                  openBookingBar={isOpenFilterBar}
                  onClose={() => {
                    openFilterBar(false);
                    setOpen(false);
                  }}
                />
              </BookingEngineProvider>,
              document.body,
            )}

          {showFilterBar &&
            typeof document !== "undefined" &&
            createPortal(
              <BookingEngineProvider>
                <FilterBar
                  selectedProperty={
                    Number.isFinite(parseInt(staahPropertyId))
                      ? parseInt(staahPropertyId)
                      : 0
                  }
                  cityDetails={cityDetails ?? {}}
                  openBookingBar={showFilterBar}
                  
              initialCheckIn={ghaCheckInData}
              initialCheckOut={ghaCheckOutData}
              initialAdults={ghaAdultsData}
              initialChildren={ghaChildrenData}
              initialHotelName={ghaPropertyNameData}
              initialCityName={ghaCityNameData}
              initialCityId={ghaCityIdData}
              isGHA = {ghaValidData}
              utmSource= {ghaUtmSourceData}

                  onClose={(isReload) => {
                    if (window.innerWidth < 768) {
                      setOpen((prev) => !prev);
                      setShowFilterBar((prev) => !prev);
                      setStaahPropertyId(null);
                    }
                    if (isReload) {
                      window.location.reload();
                    }
                    setHandleSearchProp(false);
                  }}
                  isHandleSearchProp={isHandleSearchProp}
                  staahOfferId={parseInt(staahOfferId)}
                  queryPromoCode = {queryPromoCode}
                  ratePingCode = {ratePingCode}
                />
              </BookingEngineProvider>,
              document.body,
            )}
        </section>
      </section>

      <section className="container">
        <LazyRender fallback={<ExploreSkeleton />} rootMargin="250px">
          <ExploreSection onClick={handlePropertyBookNow} />
        </LazyRender>
      </section>
      {/* Experience Section */}
      <LazyRender fallback={<ExperiencesSkeleton />} rootMargin="250px">
        <section className="mb-4 mt-4">
          <ExperienceSection onClick={handlePropertyBookNow} />
        </section>
      </LazyRender>
      {/* BrandSlider Section */}
      <LazyRender fallback={null} rootMargin="250px">
        <ResponsiveBrandSlider />
      </LazyRender>

      <section className="py-5">
        <LazyRender fallback={<PortfolioSkeleton />} rootMargin="400px">
          <PortfolioStats />
        </LazyRender>
      </section>
     
      <section className="py-0">
        {/* <LazyRender fallback={<PortfolioSkeleton />} rootMargin="400px"> */}
      
  {openRatePingConfirmation && <RatePingConfirmationCancellation ratePingConfirmation ={ratePingConfirmationCode} ratePingConfirmationCancellation = {ratePingConfirmationCancellation}
   onClickHandle={onClickHandle}></RatePingConfirmationCancellation>}
   
        {/* </LazyRender> */}
     </section>
      <style jsx>{`
        .banner-video-wrapper {
          position: relative;
          width: 100%;
          height: 100vh;
          overflow: hidden;
        }

        .banner-video {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .desktop-video {
          display: block;
        }

        .mobile-video {
          display: none;
        }

        @media (max-width: 768px) {
          .desktop-video {
            display: none;
          }
          .mobile-video {
            display: block;
          }
        }
      `}</style>
    </>
  );
}

function LazyRender({ children, fallback = null, rootMargin = "200px" }) {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isVisible) return;
    if (typeof window === "undefined") return;

    // Old browsers: render immediately.
    if (!("IntersectionObserver" in window)) {
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry?.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { root: null, rootMargin, threshold: 0.01 },
    );

    if (containerRef.current) observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, [isVisible, rootMargin]);

  return <div ref={containerRef}>{isVisible ? children : fallback}</div>;
}
